export enum UserTypes {
  WEBMASTER = 'webmaster',
  ADVERTISER = 'advertiser',
}
